export default "__VITE_ASSET__427932b7__"